import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import {
  FiMail,
  FiPhone,
  FiMapPin,
  FiUser,
  FiBriefcase,
  FiSend,
  FiGlobe,
  FiCheckCircle,
  FiArrowRight,
} from 'react-icons/fi';
import { BsLinkedin } from 'react-icons/bs';

const Contact = () => {
  const [formData, setFormData] = useState({
    fullName: '',
    companyName: '',
    email: '',
    phone: '',
    industry: '',
    subject: '',
    message: '',
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });

  useEffect(() => {
    const handleMouseMove = (e) => {
      setMousePosition({ x: e.clientX, y: e.clientY });
    };
    window.addEventListener('mousemove', handleMouseMove);
    return () => window.removeEventListener('mousemove', handleMouseMove);
  }, []);

  const industries = [
    'Oil & Petroleum',
    'Heavy Machinery & Engineering',
    'Agriculture & Horticulture',
    'Marine & Shipping',
    'Mining (Surface & Underground)',
    'Power Generation & Utilities',
    'Automotive Service & Repair',
    'Construction & Infrastructure',
    'Manufacturing & Fabrication',
    'Defense & Railways',
    'Other',
  ];

  const subjects = [
    'Product Quote',
    'Technical Support',
    'Partnership Inquiry',
    'Bulk Order',
    'Custom Solution',
    'Other',
  ];

  const contactChannels = [
    {
      icon: FiMail,
      title: 'Email',
      value: 'vpchemtechnologies19@gmail.com',
      link: 'mailto:vpchemtechnologies19@gmail.com',
      gradient: 'from-vp-blue-600 to-vp-blue-500',
    },
    {
      icon: FiGlobe,
      title: 'Website',
      value: 'www.vpchemtech.com',
      link: 'https://www.vpchemtech.com',
      gradient: 'from-vp-green-600 to-vp-green-500',
    },
  ];

  const phoneNumbers = [
    { number: '+91 9371640163', name: 'Sanjay Vyas', gradient: 'from-vp-green-600 to-vp-green-500' },
    { number: '+91 9763728119', name: 'Ranjit Lambe', gradient: 'from-vp-blue-600 to-vp-blue-500' },
    { number: '+91 9730006754', name: 'Jiten A. Pradhan', gradient: 'from-vp-grey-700 to-vp-grey-600' },
  ];

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const sendEmail = async ({ to, subject, html }) => {
    const form = new FormData();
    form.append('organizationId', 'SamHealthNew');
    form.append('to', to);
    form.append('subject', subject);
    form.append('html', html);
    
    try {
      const response = await fetch('https://imageupload.scontiapp.com/api/send-one/', {
        method: 'POST',
        body: form
      });
      return response.ok;
    } catch (err) {
      console.error('Email send error:', err);
      return false;
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    // Format email HTML body
    const emailHtml = `
      <!DOCTYPE html>
      <html>
        <head>
          <style>
            body { font-family: Arial, sans-serif; line-height: 1.6; color: #333; }
            .container { max-width: 600px; margin: 0 auto; padding: 20px; background: #ffffff; }
            .header { background: linear-gradient(135deg, #00875a 0%, #0066cc 100%); color: white; padding: 30px; text-align: center; border-radius: 10px 10px 0 0; }
            .alert-badge { background: #ff6b35; color: white; padding: 8px 16px; border-radius: 20px; font-size: 12px; font-weight: bold; display: inline-block; margin-bottom: 10px; }
            .content { background: #f9f9f9; padding: 30px; border-radius: 0 0 10px 10px; }
            .field { margin-bottom: 20px; }
            .label { font-weight: bold; color: #00875a; margin-bottom: 5px; font-size: 14px; text-transform: uppercase; }
            .value { background: white; padding: 12px; border-radius: 5px; border-left: 4px solid #00875a; font-size: 16px; }
            .footer { text-align: center; padding: 20px; color: #666; font-size: 12px; border-top: 2px solid #e0e0e0; margin-top: 20px; }
            .highlight { color: #0066cc; font-weight: bold; }
            .urgent { background: #fff3cd; padding: 15px; border-left: 4px solid #ffc107; margin-bottom: 20px; border-radius: 5px; }
          </style>
        </head>
        <body>
          <div class="container">
            <div class="header">
              <div class="alert-badge">🌐 NEW WEBSITE INQUIRY</div>
              <h2 style="margin: 10px 0;">Contact Form Submission</h2>
              <p style="margin: 5px 0; font-size: 14px;">VP Chem Technologies Website</p>
              <p style="margin: 5px 0; font-size: 12px; opacity: 0.9;">www.vpchemtech.com</p>
            </div>
            <div class="content">
              <div class="urgent">
                <strong>⚡ Action Required:</strong> A potential customer has submitted an inquiry through your website. Please respond within 24 hours for the best customer experience.
              </div>
              
              <h3 style="color: #333; margin-bottom: 20px; border-bottom: 2px solid #00875a; padding-bottom: 10px;">
                📋 Customer Details
              </h3>
              
              <div class="field">
                <div class="label">👤 Full Name:</div>
                <div class="value">${formData.fullName}</div>
              </div>
              <div class="field">
                <div class="label">🏢 Company Name:</div>
                <div class="value">${formData.companyName}</div>
              </div>
              <div class="field">
                <div class="label">📧 Email Address:</div>
                <div class="value"><a href="mailto:${formData.email}" style="color: #0066cc; text-decoration: none;">${formData.email}</a></div>
              </div>
              <div class="field">
                <div class="label">📱 Phone Number:</div>
                <div class="value"><a href="tel:${formData.phone}" style="color: #0066cc; text-decoration: none;">${formData.phone}</a></div>
              </div>
              <div class="field">
                <div class="label">🏭 Industry:</div>
                <div class="value">${formData.industry || 'Not specified'}</div>
              </div>
              <div class="field">
                <div class="label">📌 Subject/Inquiry Type:</div>
                <div class="value"><strong>${formData.subject || 'General Inquiry'}</strong></div>
              </div>
              
              <h3 style="color: #333; margin: 30px 0 20px 0; border-bottom: 2px solid #00875a; padding-bottom: 10px;">
                💬 Customer Message
              </h3>
              <div class="field">
                <div class="value" style="min-height: 80px; white-space: pre-wrap;">${formData.message}</div>
              </div>
              
              <h3 style="color: #333; margin: 30px 0 20px 0; border-bottom: 2px solid #00875a; padding-bottom: 10px;">
                ⏰ Submission Details
              </h3>
              <div class="field">
                <div class="label">📅 Date & Time:</div>
                <div class="value">${new Date().toLocaleString('en-IN', { 
                  timeZone: 'Asia/Kolkata',
                  dateStyle: 'full',
                  timeStyle: 'long'
                })}</div>
              </div>
              <div class="field">
                <div class="label">🌐 Source:</div>
                <div class="value">Website Contact Form (www.vpchemtech.com/contact)</div>
              </div>
            </div>
            <div class="footer">
              <p><strong>⚠️ This is an automated notification from VP Chem Technologies website.</strong></p>
              <p>Please respond to the customer directly at: <span class="highlight">${formData.email}</span></p>
              <p style="margin-top: 15px; font-size: 11px; color: #999;">
                This email was generated automatically when a visitor submitted the contact form on your website.<br/>
                © ${new Date().getFullYear()} VP Chem Technologies LLP. All rights reserved.
              </p>
            </div>
          </div>
        </body>
      </html>
    `;

    // Send email
    const emailSent = await sendEmail({
      to: 'vpchemtechnologies19@gmail.com',
      subject: `🌐 NEW WEBSITE INQUIRY | ${formData.subject || 'General Inquiry'} | ${formData.fullName} | ${formData.companyName}`,
      html: emailHtml
    });

    setIsSubmitting(false);

    if (emailSent) {
      setIsSuccess(true);
      
      // Reset form after 5 seconds
      setTimeout(() => {
        setFormData({
          fullName: '',
          companyName: '',
          email: '',
          phone: '',
          industry: '',
          subject: '',
          message: '',
        });
        setIsSuccess(false);
      }, 5000);
    } else {
      alert('There was an error submitting your inquiry. Please try again or contact us directly.');
    }
  };

  // Molecular pattern
  const MolecularPattern = () => (
    <svg className="absolute inset-0 w-full h-full" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <pattern id="molecule-contact" x="0" y="0" width="200" height="200" patternUnits="userSpaceOnUse">
          <circle cx="20" cy="20" r="3" fill="currentColor" opacity="0.3" />
          <circle cx="80" cy="40" r="4" fill="currentColor" opacity="0.2" />
          <circle cx="140" cy="70" r="2" fill="currentColor" opacity="0.4" />
          <line x1="20" y1="20" x2="80" y2="40" stroke="currentColor" strokeWidth="0.5" opacity="0.2" />
        </pattern>
      </defs>
      <rect width="100%" height="100%" fill="url(#molecule-contact)" />
    </svg>
  );

  return (
    <div className="min-h-screen overflow-hidden bg-vp-cream-50">
      {/* Section 1: Page Header & Core Message */}
      <section className="relative min-h-[80vh] flex items-center justify-center overflow-hidden pt-32">
        {/* Dynamic Gradient Background */}
        <div className="absolute inset-0 bg-gradient-to-br from-vp-cream-100 via-white to-vp-cream-200">
          <div 
            className="absolute inset-0 opacity-20"
            style={{
              background: `radial-gradient(circle at ${mousePosition.x}px ${mousePosition.y}px, rgba(0, 135, 81, 0.15), transparent 50%)`,
            }}
          />
        </div>

        {/* Molecular Pattern */}
        <div className="absolute inset-0 text-vp-green-400 opacity-10">
          <MolecularPattern />
        </div>

        {/* Floating particles */}
        <div className="absolute inset-0 overflow-hidden">
          {[...Array(20)].map((_, i) => (
            <motion.div
              key={i}
              className="absolute"
              style={{
                left: `${Math.random() * 100}%`,
                top: `${Math.random() * 100}%`,
              }}
              animate={{
                y: [0, -60, 0],
                opacity: [0.2, 0.6, 0.2],
              }}
              transition={{
                duration: 6 + Math.random() * 3,
                repeat: Infinity,
                delay: Math.random() * 3,
              }}
            >
              <div className="w-3 h-3 bg-vp-green-400 rounded-full" />
            </motion.div>
          ))}
        </div>

        {/* Content */}
        <div className="relative z-10 container mx-auto px-4 lg:px-8">
          <motion.div
            className="max-w-5xl mx-auto text-center"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            {/* Badge */}
            <motion.div
              className="inline-flex items-center space-x-3 bg-gradient-to-r from-vp-green-100 to-vp-blue-100 px-6 py-3 rounded-full text-vp-green-700 mb-8 border border-vp-green-400/30 shadow-md"
              animate={{ scale: [1, 1.05, 1] }}
              transition={{ duration: 2, repeat: Infinity }}
            >
              <FiMail className="text-vp-green-600 text-2xl" />
              <span className="font-semibold">Get in Touch</span>
            </motion.div>

            {/* Headline */}
            <h1 className="text-4xl md:text-5xl font-bold text-vp-grey-900 mb-8 leading-tight">
              Connect with{' '}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-vp-green-600 to-vp-blue-600">
                VP Chem Technologies LLP
              </span>
            </h1>

            {/* Sub-headline */}
            <motion.p
              className="text-xl md:text-2xl text-black mb-12 max-w-4xl mx-auto leading-relaxed"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.5 }}
            >
              Whether you need a{' '}
              <span className="text-vp-green-600 font-bold">quote, technical support</span>, or want to discuss a
              custom industrial solution, our{' '}
              <span className="text-vp-blue-600 font-bold">expert team</span> is ready to assist you.
            </motion.p>
          </motion.div>
        </div>
      </section>

      {/* Section 2: Phone Numbers */}
      <section className="py-16 md:py-20 bg-white">
        <div className="container mx-auto px-4 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            <h3 className="text-3xl font-bold text-slate-900 mb-8 text-center flex items-center justify-center space-x-3">
              <span className="w-2 h-2 bg-green-500 rounded-full" />
              <span>📱 Phone Numbers</span>
            </h3>
            <div className="grid md:grid-cols-3 gap-6 max-w-5xl mx-auto">
              {phoneNumbers.map((phone, index) => (
                <motion.a
                  key={index}
                  href={`tel:${phone.number}`}
                  initial={{ opacity: 0, y: 50 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: index * 0.1 }}
                  whileHover={{ scale: 1.05, y: -5 }}
                  className="group relative bg-white rounded-3xl p-8 shadow-xl border-2 border-slate-200 hover:border-green-400 transition-all duration-300"
                >
                  <div className={`absolute inset-0 bg-gradient-to-br ${phone.gradient} opacity-0 group-hover:opacity-10 blur-xl transition-opacity duration-500 rounded-3xl`} />
                  
                  <div className="relative text-center">
                    <div className={`w-16 h-16 bg-gradient-to-br ${phone.gradient} rounded-2xl flex items-center justify-center mx-auto mb-4`}>
                      <FiPhone className="w-8 h-8 text-white" />
                    </div>
                    {phone.name && <p className="text-lg font-semibold text-slate-700 mb-1">{phone.name}</p>}
                    <p className="text-xl font-bold text-slate-900">{phone.number}</p>
                  </div>
                </motion.a>
              ))}
            </div>
          </motion.div>
        </div>
      </section>

      {/* Section 3: Inquiry Form */}
      <section className="py-24 md:py-32 bg-gradient-to-br from-vp-grey-700 via-vp-grey-600 to-vp-grey-700 text-white relative overflow-hidden bg-pattern-grid">
        {/* Animated grid */}
        <div className="absolute inset-0 opacity-5">
          <div 
            className="absolute inset-0"
            style={{
              backgroundImage: `linear-gradient(to right, rgba(99, 102, 241, 0.3) 1px, transparent 1px),
                                linear-gradient(to bottom, rgba(99, 102, 241, 0.3) 1px, transparent 1px)`,
              backgroundSize: '50px 50px',
            }}
          />
        </div>

        <div className="relative container mx-auto px-4 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            {/* Section Header */}
            <div className="text-center mb-16">
              <motion.span
                className="inline-block px-6 py-2 bg-indigo-500/20 backdrop-blur-xl rounded-full text-indigo-600 font-semibold mb-6 border border-indigo-600/30"
                initial={{ scale: 0 }}
                whileInView={{ scale: 1 }}
                viewport={{ once: true }}
                transition={{ type: "spring" }}
              >
                📝 Send Us a Message
              </motion.span>
              
              <h2 className="text-5xl md:text-6xl font-black mb-6">
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-indigo-400 to-purple-400">
                  Inquiry Form
                </span>
              </h2>
              
              <p className="text-xl md:text-2xl text-black max-w-4xl mx-auto leading-relaxed">
                Please use the form below for all product inquiries, quote requests, and technical consultations.
                <br />
                <span className="text-vp-blue-600 font-bold">We aim to respond within one business day.</span>
              </p>
            </div>

            {/* Form */}
            <motion.div
              className="max-w-4xl mx-auto bg-white rounded-3xl p-10 shadow-2xl border-2 border-vp-grey-200"
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
            >
              {isSuccess ? (
                <motion.div
                  initial={{ scale: 0 }}
                  animate={{ scale: 1 }}
                  className="text-center py-16"
                >
                  <motion.div
                    className="w-24 h-24 bg-gradient-to-br from-vp-green-500 to-vp-blue-500 rounded-full flex items-center justify-center mx-auto mb-6"
                    animate={{ rotate: 360 }}
                    transition={{ duration: 0.6 }}
                  >
                    <FiCheckCircle className="w-12 h-12 text-white" />
                  </motion.div>
                  <h3 className="text-4xl font-bold text-vp-grey-900 mb-4">Thank You!</h3>
                  <p className="text-xl text-black">
                    Your inquiry has been submitted successfully. We'll get back to you within one business day.
                  </p>
                </motion.div>
              ) : (
                <form onSubmit={handleSubmit} className="space-y-6">
                  <div className="grid md:grid-cols-2 gap-6">
                    {/* Full Name */}
                    <div>
                      <label className="block text-sm font-bold text-vp-grey-900 mb-2 flex items-center space-x-2">
                        <FiUser className="text-vp-green-600" />
                        <span>Full Name *</span>
                      </label>
                      <input
                        type="text"
                        name="fullName"
                        value={formData.fullName}
                        onChange={handleChange}
                        required
                        className="w-full px-6 py-4 bg-vp-cream-50 border-2 border-vp-grey-300 rounded-2xl text-vp-grey-900 placeholder-vp-grey-500 focus:border-vp-green-500 focus:ring-2 focus:ring-vp-green-500/50 transition-all outline-none"
                        placeholder="Enter your full name"
                      />
                    </div>

                    {/* Company Name */}
                    <div>
                      <label className="block text-sm font-bold text-vp-grey-900 mb-2 flex items-center space-x-2">
                        <FiBriefcase className="text-vp-blue-600" />
                        <span>Company Name *</span>
                      </label>
                      <input
                        type="text"
                        name="companyName"
                        value={formData.companyName}
                        onChange={handleChange}
                        required
                        className="w-full px-6 py-4 bg-vp-cream-50 border-2 border-vp-grey-300 rounded-2xl text-vp-grey-900 placeholder-vp-grey-500 focus:border-vp-blue-500 focus:ring-2 focus:ring-vp-blue-500/50 transition-all outline-none"
                        placeholder="Enter your company name"
                      />
                    </div>
                  </div>

                  <div className="grid md:grid-cols-2 gap-6">
                    {/* Email */}
                    <div>
                      <label className="block text-sm font-bold text-vp-grey-900 mb-2 flex items-center space-x-2">
                        <FiMail className="text-vp-green-600" />
                        <span>Email Address *</span>
                      </label>
                      <input
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        required
                        className="w-full px-6 py-4 bg-vp-cream-50 border-2 border-vp-grey-300 rounded-2xl text-vp-grey-900 placeholder-vp-grey-500 focus:border-vp-green-500 focus:ring-2 focus:ring-vp-green-500/50 transition-all outline-none"
                        placeholder="your.email@company.com"
                      />
                    </div>

                    {/* Phone */}
                    <div>
                      <label className="block text-sm font-bold text-vp-grey-900 mb-2 flex items-center space-x-2">
                        <FiPhone className="text-vp-blue-600" />
                        <span>Phone Number *</span>
                      </label>
                      <input
                        type="tel"
                        name="phone"
                        value={formData.phone}
                        onChange={handleChange}
                        required
                        className="w-full px-6 py-4 bg-vp-cream-50 border-2 border-vp-grey-300 rounded-2xl text-vp-grey-900 placeholder-vp-grey-500 focus:border-vp-blue-500 focus:ring-2 focus:ring-vp-blue-500/50 transition-all outline-none"
                        placeholder="+91 XXXXXXXXXX"
                      />
                    </div>
                  </div>

                  <div className="grid md:grid-cols-2 gap-6">
                    {/* Industry */}
                    <div>
                      <label className="block text-sm font-bold text-vp-grey-900 mb-2 flex items-center space-x-2">
                        <FiBriefcase className="text-vp-green-600" />
                        <span>Industry</span>
                      </label>
                      <select
                        name="industry"
                        value={formData.industry}
                        onChange={handleChange}
                        className="w-full px-6 py-4 bg-vp-cream-50 border-2 border-vp-grey-300 rounded-2xl text-vp-grey-900 focus:border-vp-green-500 focus:ring-2 focus:ring-vp-green-500/50 transition-all outline-none"
                      >
                        <option value="" className="text-slate-900">Select your industry</option>
                        {industries.map((industry) => (
                          <option key={industry} value={industry} className="text-slate-900">
                            {industry}
                          </option>
                        ))}
                      </select>
                    </div>

                    {/* Subject */}
                    <div>
                      <label className="block text-sm font-bold text-vp-grey-900 mb-2 flex items-center space-x-2">
                        <FiMail className="text-vp-blue-600" />
                        <span>Subject</span>
                      </label>
                      <select
                        name="subject"
                        value={formData.subject}
                        onChange={handleChange}
                        className="w-full px-6 py-4 bg-vp-cream-50 border-2 border-vp-grey-300 rounded-2xl text-vp-grey-900 focus:border-vp-blue-500 focus:ring-2 focus:ring-vp-blue-500/50 transition-all outline-none"
                      >
                        <option value="" className="text-slate-900">Select subject</option>
                        {subjects.map((subject) => (
                          <option key={subject} value={subject} className="text-slate-900">
                            {subject}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>

                  {/* Message */}
                  <div>
                    <label className="block text-sm font-bold text-vp-grey-900 mb-2 flex items-center space-x-2">
                      <FiMail className="text-vp-green-600" />
                      <span>Your Message *</span>
                    </label>
                    <textarea
                      name="message"
                      value={formData.message}
                      onChange={handleChange}
                      required
                      rows="6"
                      className="w-full px-6 py-4 bg-vp-cream-50 border-2 border-vp-grey-300 rounded-2xl text-vp-grey-900 placeholder-vp-grey-500 focus:border-vp-green-500 focus:ring-2 focus:ring-vp-green-500/50 transition-all outline-none resize-none"
                      placeholder="Please tell us how we can help you..."
                    ></textarea>
                  </div>

                  {/* Submit Button */}
                  <motion.button
                    type="submit"
                    disabled={isSubmitting}
                    whileHover={{ scale: 1.02 }}
                    whileTap={{ scale: 0.98 }}
                    className="w-full px-10 py-6 bg-gradient-to-r from-indigo-600 to-purple-600 text-white font-bold text-xl rounded-2xl hover:shadow-2xl hover:shadow-indigo-500/50 transition-all duration-300 flex items-center justify-center space-x-3 disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    {isSubmitting ? (
                      <>
                        <motion.div
                          className="w-6 h-6 border-2 border-white border-t-transparent rounded-full"
                          animate={{ rotate: 360 }}
                          transition={{ duration: 1, repeat: Infinity, ease: "linear" }}
                        />
                        <span>Submitting...</span>
                      </>
                    ) : (
                      <>
                        <FiSend className="text-2xl" />
                        <span>Submit Inquiry</span>
                      </>
                    )}
                  </motion.button>
                </form>
              )}
            </motion.div>
          </motion.div>
        </div>
      </section>

      {/* Section 3: Contact Information */}
      <section className="py-24 md:py-32 bg-gradient-to-br from-slate-50 via-gray-50 to-slate-100 relative">
        <div className="container mx-auto px-4 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            {/* Section Header */}
            <div className="text-center mb-16">
              <motion.span
                className="inline-block px-6 py-2 bg-gradient-to-r from-vp-green-100 to-vp-blue-100 rounded-full text-vp-green-700 font-semibold mb-6 shadow-md"
                initial={{ scale: 0 }}
                whileInView={{ scale: 1 }}
                viewport={{ once: true }}
                transition={{ type: "spring" }}
              >
                📞 Reach Out to Us
              </motion.span>
              
              <h2 className="text-5xl md:text-6xl font-black text-slate-900 mb-6">
                Contact{' '}
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-vp-green-600 to-vp-blue-600">
                  Information
                </span>
              </h2>
              
              <p className="text-xl md:text-2xl text-black max-w-3xl mx-auto leading-relaxed">
                Reach out to us through the following channels
              </p>
            </div>

            <div className="max-w-6xl mx-auto space-y-12">
              {/* Email & Website */}
              <div>
                <h3 className="text-3xl font-bold text-slate-900 mb-6 flex items-center space-x-3">
                  <span className="w-2 h-2 bg-indigo-500 rounded-full" />
                  <span>📧 Email & Website</span>
                </h3>
                <div className="grid md:grid-cols-2 gap-6">
                  {contactChannels.map((channel, index) => (
                    <motion.a
                      key={index}
                      href={channel.link}
                      target="_blank"
                      rel="noopener noreferrer"
                      initial={{ opacity: 0, x: -50 }}
                      whileInView={{ opacity: 1, x: 0 }}
                      viewport={{ once: true }}
                      transition={{ delay: index * 0.1 }}
                      whileHover={{ scale: 1.03, y: -5 }}
                      className="group relative bg-white rounded-3xl p-8 shadow-xl border-2 border-slate-200 hover:border-vp-green-400 transition-all duration-300"
                    >
                      <div className={`absolute inset-0 bg-gradient-to-br ${channel.gradient} opacity-0 group-hover:opacity-10 blur-xl transition-opacity duration-500 rounded-3xl`} />
                      
                      <div className="relative flex items-start space-x-6">
                        <div className={`w-16 h-16 bg-gradient-to-br ${channel.gradient} rounded-2xl flex items-center justify-center flex-shrink-0`}>
                          <channel.icon className="w-8 h-8 text-white" />
                        </div>
                        <div className="flex-1">
                          <h4 className="text-xl font-bold text-slate-900 mb-2">{channel.title}</h4>
                          <p className="text-black break-all">{channel.value}</p>
                        </div>
                        <FiArrowRight className="w-6 h-6 text-slate-400 group-hover:text-vp-green-600 group-hover:translate-x-2 transition-all" />
                      </div>
                    </motion.a>
                  ))}
                </div>
              </div>

              {/* Office Address */}
              <div>
                <h3 className="text-3xl font-bold text-slate-900 mb-6 flex items-center space-x-3">
                  <span className="w-2 h-2 bg-vp-blue-500 rounded-full" />
                  <span>📍 Office Address</span>
                </h3>
                <motion.div
                  initial={{ opacity: 0, scale: 0.9 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  viewport={{ once: true }}
                  whileHover={{ scale: 1.02 }}
                  className="bg-white rounded-3xl p-10 shadow-2xl border-2 border-slate-200 hover:border-vp-blue-400 transition-all duration-300"
                >
                  <div className="flex items-start space-x-6">
                    <div className="w-20 h-20 bg-gradient-to-br from-vp-blue-500 to-vp-green-500 rounded-2xl flex items-center justify-center flex-shrink-0">
                      <FiMapPin className="w-10 h-10 text-white" />
                    </div>
                    <div>
                      <h4 className="text-2xl font-bold text-slate-900 mb-3">VP CHEM TECHNOLOGIES LLP</h4>
                      <p className="text-lg text-black leading-relaxed">
                        Plot No. 12, Arun Kunj, Bajaj Nagar,<br />
                        Nagpur, Maharashtra (INDIA)
                      </p>
                    </div>
                  </div>
                </motion.div>
              </div>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default Contact;



